import ModuleResourceCard from './component'
export default ModuleResourceCard
